(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/banner-helpers/assets/javascripts/other.js') >= 0) return;  svs.modules.push('/components/banner_common/banner-helpers/assets/javascripts/other.js');

'use strict';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var isServer = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object';
var trinidadCore = isServer && require('trinidad-core').core;


var escapeHtml = function escapeHtml(input) {
  var replacingChars = function replacingChars(match) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;'
    }[match];
  };
  return input === null || input === void 0 ? void 0 : input.replace(/[&<>"]/g, replacingChars);
};
var getCallToAction = function getCallToAction(action) {
  var viewConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  action = _objectSpread(_objectSpread({}, action), {}, {
    actionConfig: _objectSpread(_objectSpread({}, action.actionConfig), {}, {
      viewConfig: viewConfig
    })
  });
  return action;
};
var getIsAdmin = function getIsAdmin(req) {
  var _ref = (isServer ? req.userSession : svs.core.userSession) || {},
    roles = _ref.roles;
  return isServer ? req.userSession.hasRole(roles.INTERNAL) : svs.core.userSession.hasRole(roles.INTERNAL);
};
var getIsPreview = function getIsPreview(req) {
  var _ref2 = isServer ? req.userSession : svs.core.userSession,
    roles = _ref2.roles;
  return !isServer && svs.core.data.roles.includes(roles.INTERNAL);
};

var groupNumbers = function groupNumbers(text) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var wrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '<span class="inline-block">$&</span>';
  var output = (text === null || text === void 0 ? void 0 : text.replaceAll(/\d+(?:[ .,:-]\d+)*/g, wrapper)) || '';
  return config.escapeHtml ? escapeHtml(output) : output;
};
var getContentType = function getContentType(type) {
  return (type === null || type === void 0 ? void 0 : type.split(':').pop()) || 'banner';
};
var fallbackFunction = function fallbackFunction() {
  return '';
};
var getHbsCompiled = function getHbsCompiled(layoutType) {
  var _global, _global$internalInsta, _svs$banner_layouts$l;
  var hbs = isServer && ((_global = global) === null || _global === void 0 ? void 0 : (_global$internalInsta = _global.internalInstances) === null || _global$internalInsta === void 0 ? void 0 : _global$internalInsta.get('hbs'));
  return isServer ? (hbs === null || hbs === void 0 ? void 0 : hbs.cache["components-banner_layouts-".concat(layoutType, "-").concat(layoutType)]) || fallbackFunction : ((_svs$banner_layouts$l = svs.banner_layouts[layoutType]) === null || _svs$banner_layouts$l === void 0 ? void 0 : _svs$banner_layouts$l.templates[layoutType]) || fallbackFunction;
};
var getNoscriptUrl = function getNoscriptUrl(fallbackImg) {
  var _fallbackImg$availabl;
  var fallbackWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1280;
  var hasAvailableWidths = (fallbackImg === null || fallbackImg === void 0 ? void 0 : (_fallbackImg$availabl = fallbackImg.availableWidths) === null || _fallbackImg$availabl === void 0 ? void 0 : _fallbackImg$availabl.length) > 0;
  var width = hasAvailableWidths ? Math.max.apply(Math, _toConsumableArray(fallbackImg.availableWidths)) : String(fallbackWidth);
  return fallbackImg === null || fallbackImg === void 0 ? void 0 : fallbackImg.url.replace('{width}', width);
};
var getTrackingString = function getTrackingString(inputTitle, layoutType, tracking) {
  var format = isServer ? trinidadCore.components.require('utils', 'format').api : svs.utils.format;
  var title = format.safeString(inputTitle) || inputTitle;
  var widget = tracking.widget,
    position = tracking.position;
  var output = [widget.widgetType, widget.trackingId, position, layoutType, title].join('/');
  return output;
};

var getRCTools = function getRCTools(_ref3) {
  var _model$layoutConfig;
  var layoutType = _ref3.layoutType,
    model = _ref3.model,
    req = _ref3.req,
    tracking = _ref3.tracking;
  var contentType = getContentType(model.contentType);
  var hbsCompiled = getHbsCompiled(layoutType);
  var isAdmin = getIsAdmin(req);
  var isPreview = getIsPreview(req);
  var trackingString = getTrackingString(model.title, layoutType, tracking);
  var defaultThemeClass = 'default-transparent';
  var themeClass = ((_model$layoutConfig = model.layoutConfig) === null || _model$layoutConfig === void 0 ? void 0 : _model$layoutConfig.theme) || defaultThemeClass;
  var isThemeClassDefault = themeClass === defaultThemeClass;
  var getCallToActions = function getCallToActions(viewConfig) {
    return _toConsumableArray(model.callToActions).map(function (action) {
      return getCallToAction(action, viewConfig);
    });
  };
  return {
    contentType: contentType,
    getCallToActions: getCallToActions,
    hbsCompiled: hbsCompiled,
    isAdmin: isAdmin,
    isPreview: isPreview,
    isThemeClassDefault: isThemeClassDefault,
    themeClass: themeClass,
    trackingString: trackingString
  };
};
var other = {
  getCallToAction: getCallToAction,
  getNoscriptUrl: getNoscriptUrl,
  getRCTools: getRCTools,
  groupNumbers: groupNumbers
};
if (isServer) {
  module.exports = other;
} else {
  svs.banner_common.banner_helpers = _objectSpread(_objectSpread({}, svs.banner_common.banner_helpers), other);
}

 })(window);